import React from 'react'

const PlayIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="playGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 220, 150, 1)" />
          <stop offset="100%" stopColor="rgba(60, 180, 110, 1)" />
        </linearGradient>
        <filter id="playGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Play triangle */}
      <path 
        d="M8 5v14l11-7z"
        fill="url(#playGradient)"
        filter="url(#playGlow)"
      />
      
      {/* Highlight */}
      <path 
        d="M10 8v8l6-4z"
        fill="rgba(255, 255, 255, 0.2)"
      />
    </svg>
  )
}

export default PlayIcon
